export const MAX_SUGGESTIONS_COUNT = 10;
